import React from 'react';
import IntroSection from '../introSection';
import NewsSection from '../news';
import ScreeningBanner from '../screeningBanner';
import CityChange from '../CityChange';
import { isMobile } from '../../../../utils/mobile';
import './style.scss';

export default function Layout({ user, searchFocused, patient }) {
  return (
    <main>
      {!localStorage.getItem('cityId') && !localStorage.getItem('regionId') && <CityChange />}
      <IntroSection user={user} searchFocused={searchFocused} patient={patient} />
      <ScreeningBanner />
      {!isMobile() && (<NewsSection searchFocused={searchFocused} />)}
    </main>
  );
}
